import { CalendarIcon, ClockIcon } from '@heroicons/react/24/outline';
import { format } from 'date-fns';
import { AppEvent } from '../../types/event';

interface EventHeaderProps {
  event: AppEvent;
}

export default function EventHeader({ event }: EventHeaderProps) {
  const startDate = new Date(event.startAt);
  const endDate = event.endAt ? new Date(event.endAt) : null;

  return (
    <div className="mb-8">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
        {event.title}
      </h1>

      <div className="flex flex-wrap items-center gap-6 text-sm text-gray-600">
        <div className="flex items-center gap-2">
          <CalendarIcon className="h-5 w-5" />
          <span className="font-medium">
            {format(startDate, 'EEEE, MMMM d, yyyy')}
            {endDate && startDate.toDateString() !== endDate.toDateString() && (
              <> - {format(endDate, 'EEEE, MMMM d, yyyy')}</>
            )}
          </span>
        </div>
        {!event.allDay && (
          <div className="flex items-center gap-2">
            <ClockIcon className="h-5 w-5" />
            <span>
              {format(startDate, 'h:mm a')}
              {endDate && ` - ${format(endDate, 'h:mm a')}`}
            </span>
          </div>
        )}
        {event.allDay && (
          <div className="flex items-center gap-2">
            <ClockIcon className="h-5 w-5" />
            <span>All Day</span>
          </div>
        )}
      </div>
    </div>
  );
}
